<template>
    <div class="d-flex col-auto mx-auto" v-if="items.pagination.total > 0">
        <nav aria-label="Page navigation">
            <ul class="pagination">
                <li class="page-item pagination-prev-nav" v-if="items.pagination.current_page > 1">
                    <a class="page-link" href="#" aria-label="Previous"
                        @click.prevent="getRemates(items.pagination.current_page - 1)">
                        <span aria-hidden="true">&laquo;</span>
                        <span class="visually-hidden">Previous</span>
                    </a>
                </li>

                <li v-for="page in pages" :key="page" class="page-item"
                    :class="{ active: items.pagination.current_page === page }">
                    <a class="page-link" href="#" @click.prevent="getRemates(page)">{{ page }}</a>
                </li>

                <li class="page-item pagination-next-nav"
                    v-if="items.pagination.current_page !== items.pagination.last_page">
                    <a class="page-link" href="#" aria-label="Next"
                        @click.prevent="getRemates(items.pagination.current_page + 1)">
                        <span aria-hidden="true">&raquo;</span>
                        <span class="visually-hidden">Next</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Object,
      required: true,
    },
  },
  computed: {
    pages() {
      if (!this.items.pagination) {
        return [];
      }

      const currentPage = this.items.pagination.current_page;
      const lastPage = this.items.pagination.last_page;
      const visiblePages = 5; 

      let startPage = Math.max(currentPage - Math.floor(visiblePages / 2), 1);
      let endPage = Math.min(startPage + visiblePages - 1, lastPage);

      if (endPage - startPage + 1 < visiblePages && endPage < lastPage) {
        startPage = Math.max(endPage - visiblePages + 1, 1);
      }

      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    },
  },
  methods: {
    // llamar al metodo getRemates del componente padre
    getRemates(page) {
      //espera dos parámetros, el primero es el id del Remate pero al no ser relevante al paginador en este caso, enviamos "null"
      this.$emit('getRemates', null, page); 
    },
  },
};
</script>